import { Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-progressing',
  templateUrl: './progressing.component.html',
  styleUrls: ['./progressing.component.scss'],
})
export class ProgressingComponent implements OnDestroy {
  progressing$ = new BehaviorSubject<boolean>(false);

  ngOnDestroy() {
    this.progressing$.complete();
  }

  show(show:boolean) {
    this.progressing$.next(show);
  }

  listenObservable(observable$: Observable<unknown>) {
    if(observable$) {
      this.progressing$.next(true);
      const handler = (sub) => {
        this.progressing$.next(false);
        if(sub) {
          sub.unsubscribe();
        }
      }

      // note: observable$.pipe(finalize( ()=>{})) // this cannot handle error case
      const sub = observable$.subscribe({
        next: () => handler(sub),
        error: () => handler(sub),
        complete: () => handler(sub)
      });
    }
  }

  listenPromise(aPromise: Promise<unknown>) {
    if(aPromise) {
      this.progressing$.next(true);
      aPromise.finally(() => this.progressing$.next(false))
    }
  }

}
